import { render } from "./ProjectEditor.vue?vue&type=template&id=07f51570&scoped=true"
import script from "./ProjectEditor.vue?vue&type=script&lang=js"
export * from "./ProjectEditor.vue?vue&type=script&lang=js"

import "./ProjectEditor.vue?vue&type=style&index=0&id=07f51570&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f51570"],['__file',"src/components/project/ProjectEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07f51570"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07f51570', __exports__)) {
    api.reload('07f51570', __exports__)
  }
  
  module.hot.accept("./ProjectEditor.vue?vue&type=template&id=07f51570&scoped=true", () => {
    api.rerender('07f51570', render)
  })

}


export default __exports__